import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { NotCreatedComponent } from './login/responses/not-created/not-created.component';
import { InvalidLoginComponent } from './login/responses/invalid-login/invalid-login.component';

import { ValidateComponent } from './login/responses/validate/validate.component';
import { CanActivateGuard } from './shared/can-activate.guard';
import { LoginEmailComponent } from './login/login-email/login-email.component';
import { LiveViewComponent } from './projects/live-view/live-view.component';
import { LiveViewGuard } from './shared/live-view.guard';
import { LoginViewComponent } from './projects/live-view/login-view/login-view.component';


const routes: Routes = [
	{
		path: '',
		redirectTo: '/home',
		pathMatch: 'full'
	},
	{
		path: 'login',
		component: LoginComponent,
		data: {
			module: 'login',
			page: 'home'
		}
  },
  {
		path: 'login_token',
		component: LoginEmailComponent,
		data: {
			module: 'login',
			page: 'home'
		}
	},
	{
		path: 'user-not-created',
		component: NotCreatedComponent,
		data: {
			module: 'login',
			page: 'user-not-created'
		}
	},
	{
		path: 'invalid-login',
		component: InvalidLoginComponent,
		data: {
			module: 'login',
			page: 'invalid-login'
		}
	},
	{
		path: 'validate',
		component: ValidateComponent,
		data: {
			module: 'login',
			page: 'validate'
		}
	},
	{
		path: 'home',
		component: HomeComponent,
		canActivate: [CanActivateGuard],
		data: {
			module: 'home',
			page: 'home',
			menu: 'home'
		}
	},
	{
		path: 'pipeline',
		// canActivate: [CanActivateGuard],
		loadChildren: () => import('./pipeline/pipeline.module').then(m => m.PipelineModule)
	},
	{
		path: 'timeline',
		// canActivate: [CanActivateGuard],
		loadChildren: () => import('./timeline/timeline.module').then(m => m.TimelineModule)
	},
	{
		path: 'finance',
		// canActivate: [CanActivateGuard],
		loadChildren: () => import('./finance/finance.module').then(m => m.FinanceModule)
	},
	{
		path: 'projects',
		// canActivate: [CanActivateGuard],
		loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule)
	},
	{
		path: 'admin',
		// canActivate: [CanActivateGuard],
		loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
	},
	{
		path: 'charge-matrix',
		// canActivate: [CanActivateGuard],
		loadChildren: () => import('./charge-matrix/charge-matrix.module').then(m => m.ChargeMatrixModule)
	},
	{
		path: '**',
		redirectTo: '/home'
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {})
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
// export const routableComponents = [PipelineModule]
